import React from 'react';
import { Link } from 'react-router-dom';
import { APP_STORE_ROUTE } from '../constants/urls';

const APP_STORE_BADGE_SRC = 'https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg';

function AppStoreBadge({ className = '', ariaLabel = 'Download on the App Store' }) {
  const combinedClassName = ['app-store-badge', className].filter(Boolean).join(' ');

  return (
    <Link
      to={APP_STORE_ROUTE}
      className={combinedClassName}
      aria-label={ariaLabel}
    >
      <img
        src={APP_STORE_BADGE_SRC}
        alt={ariaLabel}
        className="app-store-badge__image"
        loading="lazy"
      />
    </Link>
  );
}

export default AppStoreBadge;
